import Container from "./../../container";
import MultiUploadField from "./multi-upload-field";
import React from "react";
import SingleUploadField from "./upload-field";

const FileUpload = ({ onChange = null, onDelete = null, error, ...props }) => {
    return (
        <Container {...props}>
            {props.multipleFiles ? (
                <MultiUploadField
                    onChange={onChange}
                    onDelete={onDelete}
                    initialState={
                        props.value
                            ? props.value
                            : {
                                  multiFileUpload: true,
                                  uploadedFiles: []
                              }
                    }
                    {...{ ...props, error }}
                />
            ) : (
                <SingleUploadField
                    onChange={onChange}
                    onDelete={onDelete}
                    {...{ ...props, error }}
                />
            )}
        </Container>
    );
};

export default FileUpload;
